import { isEmpty } from 'lodash'
import i18n from 'i18next'

const validateRequiredNotBlank = (fieldMessage: string) => ({
   validator: (_: any, value: any) => {
      if (typeof value === 'string' && value.trim() === '') {
         return Promise.reject(new Error(fieldMessage))
      }
      if (value == null) {
         return Promise.reject(new Error(fieldMessage))
      }
      return Promise.resolve()
   }
})

const validateMaxLength = (max: number) => ({
   validator: (_: any, value: any) => {
      if (value == null) return Promise.resolve()
      const formattedValue = String(value ?? '')
      // const formattedValue = typeof value === 'number' ? String(value) : value.toString()
      // console.log('formattedValue',formattedValue, 'formattedValue.length', formattedValue.length);
      if (formattedValue.length > max) {
         console.log(
            'formattedValue: ',
            formattedValue,
            '---formattedValue.length',
            formattedValue.length,
            ' -max',
            max
         )
         return Promise.reject(new Error(i18n.t('max_character_value', { max })))
      }
      return Promise.resolve()
   }
})

const validatePositiveInteger = () => ({
   validator: (_: any, value: any) => {
      if (value == null || value == '') return Promise.resolve()
      const numberValue = Number(value)
      if (!Number.isInteger(numberValue) || numberValue <= 0) {
         console.log(
            'numberValue',
            numberValue,
            `!Number.isInteger(numberValue)  `,
            !Number.isInteger(numberValue),
            ` numberValue <= 0`,
            numberValue <= 0
         )

         return Promise.reject(new Error(i18n.t('please_enter_positive_integer')))
      }
      return Promise.resolve()
   }
})

export const createValidationRules = () => ({
   requiredEnter: validateRequiredNotBlank(i18n.t('please_enter_data')),
   requiredEnterNumber: validateRequiredNotBlank(i18n.t('please_enter_data_number')),
   requiredName: validateRequiredNotBlank(i18n.t('please_enter_name')),
   requiredTeleFb: validateRequiredNotBlank(i18n.t('please_enter_telegram_fb')),
   requiredUsername: validateRequiredNotBlank(i18n.t('please_enter_username')),
   requiredUsernameTele: validateRequiredNotBlank(i18n.t('please_enter_telegram_username')),
   requiredPhone: validateRequiredNotBlank(i18n.t('please_enter_phone')),
   requiredEmail: validateRequiredNotBlank(i18n.t('please_enter_email')),
   requiredPassword: validateRequiredNotBlank(i18n.t('please_enter_password')),
   requiredConfirmPassword: validateRequiredNotBlank(i18n.t('please_enter_confirm_password')),
   requiredChannelCode: validateRequiredNotBlank(i18n.t('please_enter_channel_code')),
   requiredChannelName: validateRequiredNotBlank(i18n.t('please_enter_channel_name')),
   requiredProductGroupCode: validateRequiredNotBlank(i18n.t('please_enter_product_group_product_code')),
   requiredProductGroupName: validateRequiredNotBlank(i18n.t('please_enter_product_group_product_name')),
   requiredProductType: validateRequiredNotBlank(i18n.t('please_select_product_type')),
   requiredProductTypeCode: validateRequiredNotBlank(i18n.t('please_enter_product_type_code')),
   requiredProductTypeName: validateRequiredNotBlank(i18n.t('please_enter_product_type_name')),
   requiredProductTypeTableName: validateRequiredNotBlank(i18n.t('please_enter_table_data_name')),
   requiredProductAttributeCode: validateRequiredNotBlank(i18n.t('please_enter_attribute_code')),
   requiredProductAttribute: validateRequiredNotBlank(i18n.t('please_enter_attribute_name')),
   requiredProductAttributeType: validateRequiredNotBlank(i18n.t('please_enter_attribute_type')),
   requiredProductAttributeTypeOption: validateRequiredNotBlank(i18n.t('please_enter_attribute_value')),
   requiredSelect: {
      required: true,
      message: i18n.t('please_select_data')
   },
   maxRuleCharacter1: validateMaxLength(1),
   maxRuleCharacter2: validateMaxLength(2),
   maxRuleCharacter4: validateMaxLength(4),
   maxRuleCharacter5: validateMaxLength(5),
   maxRuleCharacter10: validateMaxLength(10),
   maxRuleCharacter15: validateMaxLength(15),
   maxRuleCharacter20: validateMaxLength(20),
   maxRuleCharacter50: validateMaxLength(50),
   maxRuleCharacter100: validateMaxLength(100),
   maxRuleCharacter200: validateMaxLength(200),
   maxRuleCharacter256: validateMaxLength(256),
   maxRuleCharacter300: validateMaxLength(300),
   maxRuleCharacter1000: validateMaxLength(1000),
   maxRuleCharacter2000: validateMaxLength(2000),
   maxRuleCharacter4000: validateMaxLength(4000),
   requiredPositiveInteger: validatePositiveInteger(),

   emailRule: {
      pattern:
         /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: i18n.t('invalid_email_format')
   },
   passwordRule: {
      validator: (_: any, value: any) => {
         const passwordRegex = /^\S*(([0-9]+.*[A-Za-z]+\S*)|[A-Za-z]+.*([0-9]+.*)+\S)$/
         if (isEmpty(value) || (typeof value === 'string' && value.trim() === '')) {
            return Promise.reject(new Error(i18n.t('please_enter_password')))
         } else if (!passwordRegex.test(value) || value.length < 9) {
            return Promise.reject(new Error(i18n.t('invalid_password_format')))
         }
         return Promise.resolve()
      }
   },
   phoneRule: {
      pattern: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/,
      min: 10,
      message: i18n.t('invalid_phone_format')
   },
   termRule: {
      validator: (_: any, value: any) =>
         value ? Promise.resolve() : Promise.reject(new Error(i18n.t('please_accept_terms')))
   }
})
